import {
  FormField,
  type IFormFieldProps,
  type ITextareaProps,
  Textarea,
} from "@/ui-kit";
import { useId } from "react";
import { Controller, useFormContext, useFormState } from "react-hook-form";
import { get } from "../utils";
import { useTranslation } from "react-i18next";

type IProps = Omit<ITextareaProps, "label"> &
  Partial<IFormFieldProps> & {
    name: string;
    formElementClass?: string;
  };

export const TextareaControl = (props: IProps) => {
  const {
    label,
    message,
    required,
    tooltipContent,
    accessory,
    formElementClass,
    name,
    invalid,
    description,
    ...restTextareaProps
  } = props;
  const { t } = useTranslation();
  const { control } = useFormContext();
  const { errors } = useFormState();
  const errorMessage = get(errors, name)?.message as string | undefined;
  const textareaId = useId();

  const placeholder =
    props.placeholder !== undefined
      ? props.placeholder
      : label && typeof label === "string"
        ? t("placeholder.enter_what", {
            what: label.toLowerCase(),
          })
        : "";

  const inputElement = (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange: onFieldChange, onBlur, value } }) => {
        return (
          <Textarea
            {...restTextareaProps}
            required={required}
            name={name}
            onChange={onFieldChange}
            onBlur={onBlur}
            value={value}
            invalid={invalid || !!errorMessage}
            id={textareaId}
            placeholder={placeholder}
          />
        );
      }}
    />
  );

  return (
    <FormField
      label={label}
      message={message ?? errorMessage}
      description={description}
      required={required}
      tooltipContent={tooltipContent}
      className={formElementClass}
      accessory={accessory}
      htmlFor={textareaId}
      color={restTextareaProps.color}
    >
      {inputElement}
    </FormField>
  );
};
